import React from 'react';
import { useStaticQuery } from 'gatsby';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import Button from '@interness/web-core/src/components/elements/Button/Button';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import PhoneNumber from '@interness/web-core/src/components/text/PhoneNumber/PhoneNumber';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CTASection = _ref => {
  let {
    header,
    text,
    mailButtonText,
    showPhone,
    showMail,
    showAddress
  } = _ref;
  const data = useStaticQuery(query);
  const address = data.directusCompany.addresses[0];
  const phone = data.directusCompany.numbers.filter(number => number.primary && number.type === 'phone')[0];
  return ___EmotionJSX(S.Container, null, ___EmotionJSX(S.Overlay, null, ___EmotionJSX(S.Content, null, ___EmotionJSX("div", null, ___EmotionJSX("p", {
    className: "int-title",
    dangerouslySetInnerHTML: {
      __html: header
    }
  })), ___EmotionJSX("div", null, showPhone && ___EmotionJSX(Button, {
    as: "a",
    href: `tel:${phone.number}`,
    primary: true
  }, ___EmotionJSX(FaPhone, null), ___EmotionJSX(PhoneNumber, {
    number: phone.number,
    callable: false
  })), showMail && ___EmotionJSX(Button, {
    primary: !showPhone,
    as: Link,
    to: "/kontakt"
  }, ___EmotionJSX(FaEnvelope, null), ___EmotionJSX("span", null, mailButtonText))), ___EmotionJSX("div", null, ___EmotionJSX("p", null, text, ___EmotionJSX("br", null), showAddress && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(FaMapMarkerAlt, null), " ", address.street, " ", address.number, ", ", ___EmotionJSX("span", {
    className: "int-addr"
  }, address.zip_code, " ", address.city)))))), ___EmotionJSX(S.Background, {
    bgImage: data.backgroundImage.childImageSharp.original.src
  }));
};
CTASection.defaultProps = {
  header: 'Haben Sie Fragen oder benötigen Sie Hilfe?',
  text: 'Oder besuchen Sie uns persönlich in unserem Ladenlokal:',
  mailButtonText: 'E-Mail',
  showPhone: true,
  showMail: true,
  showAddress: true
};
const query = "1461545409";
export default CTASection;